import script from "./VolunteerSignupView.vue?vue&type=script&setup=true&lang=ts"
export * from "./VolunteerSignupView.vue?vue&type=script&setup=true&lang=ts"

import "./VolunteerSignupView.vue?vue&type=style&index=0&id=ca159b68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca159b68"]])

export default __exports__